import { Button } from '@skin-seoul/design-system';
import { motion, AnimatePresence } from 'motion/react';
import { COLORS, FONT_SIZES, FONT_WEIGHTS, BORDER_RADIUS, SPACING } from './constants';
import { ConfirmationOverlay } from './SharedStyles';

interface ConfirmationDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmationDialog = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}: ConfirmationDialogProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <ConfirmationOverlay initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onCancel}>
          <motion.div
            className="max-w-[400px] w-[90%]"
            style={{
              background: COLORS.background,
              borderRadius: BORDER_RADIUS.md,
              padding: SPACING.xl,
              boxShadow: `0 8px 32px ${COLORS.shadow}`,
            }}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-col items-stretch" style={{ gap: SPACING.lg }}>
              <h3
                style={{
                  fontSize: FONT_SIZES.lg,
                  fontWeight: FONT_WEIGHTS.semibold,
                  color: COLORS.text,
                  margin: `0 0 ${SPACING.md} 0`,
                  fontFamily: 'General Sans',
                }}
              >
                {title}
              </h3>
              <p
                style={{
                  fontSize: FONT_SIZES.sm,
                  color: COLORS.textSecondary,
                  margin: `0 0 ${SPACING.xl} 0`,
                  fontFamily: 'General Sans',
                  lineHeight: '1.4',
                }}
              >
                {message}
              </p>
              <div className="flex justify-end" style={{ gap: SPACING.md }}>
                <Button
                  variant="secondary"
                  className="bg-[#f5f5f5] border-none cursor-pointer font-[General_Sans] hover:opacity-90"
                  style={{ fontSize: FONT_SIZES.sm, padding: `${SPACING.sm} ${SPACING.lg}` }}
                  onClick={onCancel}
                >
                  {cancelText}
                </Button>
                <Button
                  variant="primary"
                  className="border-none cursor-pointer font-[General_Sans] hover:opacity-90"
                  style={{ fontSize: FONT_SIZES.sm, padding: `${SPACING.sm} ${SPACING.lg}` }}
                  onClick={onConfirm}
                >
                  {confirmText}
                </Button>
              </div>
            </div>
          </motion.div>
        </ConfirmationOverlay>
      )}
    </AnimatePresence>
  );
};
